import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/hezuolian1.png'
import _imports_1 from '@/assets/image/qyhzliucheng1.png'
import _imports_2 from '@/assets/image/sthzjiantou.png'
import _imports_3 from '@/assets/image/hezuo2.png'
import _imports_4 from '@/assets/image/hezuo3.png'
import _imports_5 from '@/assets/image/hezuo4.png'
import _imports_6 from '@/assets/image/hezuo5.png'
import _imports_7 from '@/assets/image/gyl1.png'
import _imports_8 from '@/assets/image/gyl2.png'
import _imports_9 from '@/assets/image/gyl3.png'
import _imports_10 from '@/assets/image/dailai1.png'
import _imports_11 from '@/assets/image/dailai2.png'
import _imports_12 from '@/assets/image/dailai3.png'
import _imports_13 from '@/assets/image/duigou.png'


const _withScopeId = n => (_pushScopeId("data-v-01baa62f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"position:relative;\" data-v-01baa62f></div><div class=\"banner container\" data-v-01baa62f><p data-v-01baa62f>自动化供应链-合作伙伴</p><div data-v-01baa62f></div></div><div class=\"pattern container\" data-v-01baa62f><div class=\"title1\" data-v-01baa62f>合作模式</div><div class=\"yellow\" data-v-01baa62f></div><div class=\"pattern1\" data-v-01baa62f><div class=\"img\" data-v-01baa62f><img src=\"" + _imports_0 + "\" alt=\"\" data-v-01baa62f></div><div class=\"right\" data-v-01baa62f><div class=\"two\" data-v-01baa62f><div class=\"course-box\" data-v-01baa62f><div class=\"liucheng\" style=\"width:104px;\" data-v-01baa62f><img src=\"" + _imports_1 + "\" alt=\"\" data-v-01baa62f><div data-v-01baa62f>注册设纪元</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-01baa62f><div class=\"liucheng\" data-v-01baa62f><img src=\"" + _imports_3 + "\" alt=\"\" data-v-01baa62f><div data-v-01baa62f>填写合作申请</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-01baa62f><div class=\"liucheng\" data-v-01baa62f><img src=\"" + _imports_4 + "\" alt=\"\" data-v-01baa62f><div data-v-01baa62f>达成合作协议</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-01baa62f><div class=\"liucheng\" data-v-01baa62f><img src=\"" + _imports_5 + "\" alt=\"\" data-v-01baa62f><div data-v-01baa62f>提供相关资料</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-01baa62f><div class=\"liucheng\" data-v-01baa62f><img src=\"" + _imports_6 + "\" alt=\"\" data-v-01baa62f><div data-v-01baa62f>设纪元整理并上架</div></div></div></div></div></div></div><div class=\"support container\" data-v-01baa62f><div class=\"title1\" data-v-01baa62f>多场景品牌展示 解锁更多商机</div><div class=\"yellow\" data-v-01baa62f></div><div class=\"one container\" data-v-01baa62f><div class=\"box\" data-v-01baa62f><div class=\"img\" data-v-01baa62f><img src=\"" + _imports_7 + "\" alt=\"\" style=\"margin-top:42px;\" data-v-01baa62f></div><div class=\"name\" data-v-01baa62f><div class=\"blue\" data-v-01baa62f></div><p data-v-01baa62f>精准触达</p></div><div class=\"text\" data-v-01baa62f>精准产品筛选，详细产品展示，以产品触达品牌</div></div><div class=\"box\" data-v-01baa62f><div class=\"img\" data-v-01baa62f><img src=\"" + _imports_8 + "\" alt=\"\" style=\"margin-top:36px;\" data-v-01baa62f></div><div class=\"name\" data-v-01baa62f><div class=\"blue\" data-v-01baa62f></div><p data-v-01baa62f>品牌展示</p></div><div class=\"text\" data-v-01baa62f>专属品牌页，产品与品牌深度绑定，提升品牌知名度</div></div><div class=\"box\" data-v-01baa62f><div class=\"img\" data-v-01baa62f><img src=\"" + _imports_9 + "\" alt=\"\" data-v-01baa62f></div><div class=\"name\" data-v-01baa62f><div class=\"blue\" data-v-01baa62f></div><p data-v-01baa62f>提高商机转化率</p></div><div class=\"text\" data-v-01baa62f> 产品信息展示明晰，多场景展示产品应用方案，提升购买转化率 </div></div></div></div><div class=\"dailai container\" data-v-01baa62f><div class=\"title1\" data-v-01baa62f>我们能为您带来什么?</div><div class=\"yellow\" data-v-01baa62f></div><div class=\"banner2\" data-v-01baa62f><div class=\"one\" style=\"margin-top:72px;\" data-v-01baa62f><img src=\"" + _imports_10 + "\" alt=\"\" data-v-01baa62f><p data-v-01baa62f>线上销售渠道增加</p></div><div class=\"one\" style=\"margin-left:1073px;\" data-v-01baa62f><img src=\"" + _imports_11 + "\" alt=\"\" data-v-01baa62f><p data-v-01baa62f>海内外客户群拓展</p></div><div class=\"one\" data-v-01baa62f><img src=\"" + _imports_12 + "\" alt=\"\" data-v-01baa62f><p data-v-01baa62f>品牌知名度提升</p></div></div></div>", 5)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "earnings container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "合作权益"),
  /*#__PURE__*/_createElementVNode("div", { class: "yellow" }),
  /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
    /*#__PURE__*/_createElementVNode("table", { style: {"width":"auto"} }, [
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", { class: "row1" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "2",
            rowSpan: "1",
            width: "508"
          }, [
            /*#__PURE__*/_createTextVNode("权益类型"),
            /*#__PURE__*/_createElementVNode("br")
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "729"
          }, "权益说明"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "202"
          }, "企业")
        ]),
        /*#__PURE__*/_createElementVNode("tr", { class: "row2" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "3",
            class: "fuwu"
          }, [
            /*#__PURE__*/_createElementVNode("div", null, "基础服务")
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "产品推广"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 由专业人员负责产品的上架、推广 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", {
          class: "row2",
          style: {"background":"#fff"}
        }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "品牌推广"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 专属企业主页，提升品牌知名度 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", { class: "row2" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "行业应用案例展示"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 全方位展示应用案例，提高商机转化率 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", {
          class: "row2",
          style: {"background":"#fff"}
        }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto",
            style: {"background":"#fff"}
          }, " 线上推广 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "营销活动"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, "参与平台线上营销活动"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", { class: "row2" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto",
            style: {"background":"#fff"}
          }, " 商机线索 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "提供商机线索"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 提供网站所得相关商机线索 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_8 = { class: "join1 container" }
const _hoisted_9 = { class: "join" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "routine" }, "立即加入", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, { to: {
            name: 'verify',
            params: {
              type: 2,
            },
          } }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_html_footer)
  ], 64))
}